module.exports = __webpack_public_path__ + "img/04.e8b8abe3.webp";